import { Link } from "react-router";
import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import styles from "./ComponentDemoLandingPage.module.css";

type CategoryCard = {
  title: string;
  description: string;
  path: string;
  count: number;
  subcategories?: { label: string; path: string; count: number }[];
};

const categories: CategoryCard[] = [
  {
    title: "Input & Forms",
    description: "Text inputs, selections, switches, and form controls",
    path: "/task-management-components/inputs",
    count: 20,
  },
  {
    title: "Files & Articles",
    description: "Images, files, articles, and media components",
    path: "/task-management-components/files-and-articles",
    count: 12,
  },
  {
    title: "ViewerComponents",
    description: "Components for displaying information and data",
    path: "/task-management-components/viewer-components",
    count: 14,
  },
  {
    title: "Cards",
    description: "Task card components and variants",
    path: "/task-management-components/cards",
    count: 4,
  },
  {
    title: "Modals & Sheets",
    description: "Modal dialogs, bottom sheets, and overlays",
    path: "/task-management-components/modals",
    count: 4,
  },
  {
    title: "Other",
    description: "Miscellaneous components and utilities",
    path: "/task-management-components/other",
    count: 1,
  },
];

function ComponentDemoLandingPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="Task Management Components" currentAsH1 />
      <FullscreenContent className={styles["content"]}>
        <p className={styles["description"]}>
          Browse all task management components organized by category. Use these
          components to build custom task types.
        </p>

        <div className={styles["categories"]}>
          {categories.map((category) => (
            <div key={category.title} className={styles["category-card"]}>
              <div className={styles["category-header"]}>
                <FixaText tagName="h2" textStyle="Heading.L">
                  {category.title}
                </FixaText>
                <span className={styles["count"]}>
                  {category.count} components
                </span>
              </div>
              <p className={styles["category-description"]}>
                {category.description}
              </p>

              {category.subcategories ? (
                <div className={styles["subcategories"]}>
                  {category.subcategories.map((sub) => (
                    <Link
                      key={sub.path}
                      to={sub.path}
                      className={styles["subcategory-link"]}
                    >
                      <span className={styles["subcategory-label"]}>
                        {sub.label}
                      </span>
                      <span className={styles["subcategory-count"]}>
                        ({sub.count})
                      </span>
                    </Link>
                  ))}
                </div>
              ) : (
                <Link to={category.path} className={styles["view-all-link"]}>
                  View components →
                </Link>
              )}
            </div>
          ))}
        </div>
      </FullscreenContent>
    </Fullscreen>
  );
}

export default ComponentDemoLandingPage;
